import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { toast } from 'sonner';

import { AuthLayout } from '@/components/layouts/AuthLayout';
import { ClientAuthBrandPanel } from '@/components/layouts/components/ClientAuthBrandPanel';
import { ClientLoginForm } from '@/features/auth/components/ClientLoginForm';

export const Route = createFileRoute('/client_/login')({
  component: ClientLoginPage,
});

function ClientLoginPage() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('reason') === 'idle') {
      toast.info('You were signed out due to inactivity.');
    }
  }, []);

  return (
    <AuthLayout brandPanel={<ClientAuthBrandPanel />} formSide="right">
      <ClientLoginForm />
    </AuthLayout>
  );
}
